import { useProfile } from "@/context/ProfileContext";
import { GraduationCap, Luggage, Sparkles, Heart, User, CalendarHeart } from "lucide-react";

const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const Item = ({ icon: Icon, label, onClick, testId, badge }) => (
  <button onClick={onClick} data-testid={testId}
    className="relative flex-1 flex flex-col items-center justify-center gap-0.5 min-h-[56px] text-[#5C534E] active:text-[#C87D75] transition-colors">
    <Icon size={20} strokeWidth={1.7} />
    <span className="text-[10px] font-display">{label}</span>
    {badge > 0 && (
      <span className="absolute top-1.5 right-[calc(50%-18px)] bg-[#E5A8A0] text-white text-[10px] min-w-[18px] h-[18px] px-1 rounded-full flex items-center justify-center" data-testid="mobile-nav-list-count">
        {badge}
      </span>
    )}
  </button>
);

export const MobileNav = ({ isBorn, onOpenList, onOpenProfile }) => {
  const { profile, wishlist } = useProfile();
  if (!profile) return null;
  return (
    <nav data-testid="mobile-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-xl border-t border-[#EAE3DC] pb-safe shadow-[0_-4px_20px_rgba(45,40,37,0.06)]">
      <div className="flex">
        <Item icon={GraduationCap} label="Scuola" testId="mobile-nav-scuola" onClick={() => go("scuola")} />
        {isBorn
          ? <Item icon={CalendarHeart} label="Consigli" testId="mobile-nav-consigli" onClick={() => go("consigli")} />
          : <Item icon={Luggage} label="Valigia" testId="mobile-nav-valigia" onClick={() => go("valigia")} />}
        <Item icon={Sparkles} label="Look" testId="mobile-nav-look" onClick={() => go("look")} />
        <Item icon={Heart} label="Lista" testId="mobile-nav-lista" onClick={onOpenList} badge={wishlist.length} />
        <Item icon={User} label="Profilo" testId="mobile-nav-profilo" onClick={onOpenProfile} />
      </div>
    </nav>
  );
};
